import { createContext, useCallback, useContext, useMemo } from 'react';

import { EMPTY_OBJECT } from '../constants';

import { ApiError } from './errors';
import { ApiContextProps, ApiContextType } from './types';
import { VoladeumAxios } from './voladeum';

export const ApiContext = createContext<ApiContextType>({
  Voladeum: new VoladeumAxios(),
  handleError: () => {},
});

export const useClientContext = () => useContext(ApiContext);

export const ClientProvider = ({
  children,
  host = EMPTY_OBJECT,
  errorCallback = () => {},
}: ApiContextProps) => {
  const Voladeum = useMemo(() => new VoladeumAxios(host.VOLADEUM), [host.VOLADEUM]);

  const handleError = useCallback(
    (err: ApiError | unknown) => {
      errorCallback(err);
      return err;
    },
    [errorCallback]
  );

  const context = useMemo(() => ({ Voladeum, handleError }), [Voladeum, handleError]);
  return <ApiContext.Provider value={context}>{children}</ApiContext.Provider>;
};
